import React from 'react';

import { observer } from 'mobx-react';

import InfoIcon from '@mui/icons-material/Info';

import { Button } from 'components/Button';

import Plus from 'ui/Icons/Plus';

import { useStore } from 'utils/hooks/store';

import { AssignmentRuleTypeEnum } from 'stores/AssignmentRules/AssignmentRules';

import { colors } from 'theme/colors';

import EmptyAssignmentRules from './EmptyAssignmentRules';
import AssignmentRule from './AssignmentRule/AssignmentRule';

import { PipelinesInfoContainer } from './styles';

const AssignmentRulesComponent: React.FC<{
  typeOfAssignmentRule: AssignmentRuleTypeEnum;
}> = ({ typeOfAssignmentRule }) => {
  const {
    assignmentRules: { createEmptyRule, assignmentRules, assignmentRulesPipelines, createEmptyRulePipeline },
  } = useStore();

  const assignmentRulesToRender =
    typeOfAssignmentRule === AssignmentRuleTypeEnum.Collaborators ? assignmentRules : assignmentRulesPipelines;

  const isEmpty =
    typeOfAssignmentRule === AssignmentRuleTypeEnum.Collaborators
      ? assignmentRules.length === 0
      : assignmentRulesPipelines.length === 0;

  const createEmptyRuleFunction =
    typeOfAssignmentRule === AssignmentRuleTypeEnum.Collaborators ? createEmptyRule : createEmptyRulePipeline;

  return (
    <>
      {typeOfAssignmentRule === AssignmentRuleTypeEnum.Pipeline && (
        <PipelinesInfoContainer>
          <InfoIcon htmlColor={colors.text.secondary} />
          <p>
            Pipeline rules are applied only once, when an event is submitted. Events will be assigned to the first
            matching pipeline rule. If no rules match, the event will be added to the default pipeline.
          </p>
        </PipelinesInfoContainer>
      )}
      {isEmpty && <EmptyAssignmentRules />}
      {assignmentRulesToRender.map((rule) => (
        <AssignmentRule typeOfAssignmentRule={typeOfAssignmentRule} key={rule.uuid} rule={rule} />
      ))}

      <Button
        fullWidth
        size="large"
        disabled={false}
        variant="outlined"
        startIcon={<Plus />}
        sx={{ marginTop: '16px' }}
        onClick={() => createEmptyRuleFunction()}
      >
        Add Rule
      </Button>
    </>
  );
};

export default observer(AssignmentRulesComponent);
